import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import Input from 'components/common/Input';
import SoftBadge from 'components/common/SoftBadge';
import { currency, noCurrency } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Dues = ({ num, type, errors, register, setValue, watch, verifyFields }) => {
 //  const [config] = useState(watch('defaultValues'));
 const [classDate, setClassDate] = useState(watch('dateDiffs').some(e => e === `${type}.date-${num}`));
 const [classFee, setClassFee] = useState(
  noCurrency(watch(`${type}.fee-${num}`)) <
   noCurrency(watch('defaultValues')[type === 'quotasInitial' ? 'minFeeIni' : 'minFeeFnc'])
 );
 const [disabled, setDisabled] = useState(type === 'quotasInitial' ? watch('initials') == 1 : watch('financings') == 1);
 const [disabledDate, setDisabledDate] = useState(type === 'quotasInitial' && num == 1 ? false : watch('notAdmin'));
 //  const [defaultValue, setDefaultValue] = useState(
 //   type === 'quotasInitial' ? config.iniVal - config.minInitialPay : config.totals - config.iniVal
 //  );

 useEffect(() => {
  setDisabled(type === 'quotasInitial' ? watch('initials') == 1 : watch('financings') == 1);
  setDisabledDate(type === 'quotasInitial' && num == 1 ? false : watch('notAdmin'));
  // setDefaultValue(type === 'quotasInitial' ? config.iniVal - config.minInitialPay : config.totals - config.iniVal);
  setClassDate(watch('dateDiffs').some(e => e === `${type}.date-${num}`));
  setClassFee(
   noCurrency(watch(`${type}.fee-${num}`)) <
    noCurrency(watch('defaultValues')[type === 'quotasInitial' ? 'minFeeIni' : 'minFeeFnc'])
  );
 }, [watch(['quotasInitial', 'quotasFinan', 'dateDiffs'])]);

 const onFocus = ({ target }) => {
  target.select();
  verifyFields({ keyCode: 'focus', target });
 };

 const onBlur = e => verifyFields(e);

 const onKeyDown = key => (/13|27/.test(key.keyCode) ? verifyFields(key) : '');

 const onChange = ({ target: { name, value } }) => setValue(name, currency(value, true));

 return (
  <Flex justifyContent="between" alignItems="center">
   <SoftBadge pill bg="primary" className="me-2">
    {num}
   </SoftBadge>
   <div className="position-relative me-2" style={{ maxWidth: '150px' }}>
    <FontAwesomeIcon icon="calendar-alt" className="me-2 position-absolute top-0 end-0 fs--2 z-index-2 translate-middle-y" />
    <Input
     type="simple-date"
     errors={errors}
     name={`${type}.date-${num}`}
     formControlProps={{
      ...register(`${type}.date-${num}`, {
       required: 'Debe especificar el monto de la inicial'
      }),
      className: classDate ? 'text-warning bg-soft-warning' : '',
      size: 'sm',
      autoComplete: 'off',
      onFocus,
      onBlur,
      onKeyDown,
      readOnly: disabledDate
     }}
    />
   </div>
   <div className="position-relative">
    <FontAwesomeIcon icon="dollar-sign" className="me-2 position-absolute top-0 end-0 fs--1 z-index-2 translate-middle-y" />
    <Input
     type="simple-text"
     errors={errors}
     name={`${type}.fee-${num}`}
     placeholder="Monto"
     formControlProps={{
      ...register(`${type}.fee-${num}`, {
       required: 'Debe especificar el monto de la inicial',
       validate: value => !/[^0-9,.$ ]/g.test(value) || 'Caracteres invalidos'
      }),
      className: classFee ? 'text-warning bg-soft-warning' : '',
      size: 'sm',
      readOnly: disabled,
      autoComplete: 'off',
      //defaultValue: currency(defaultValue, true),
      onFocus,
      onBlur,
      onKeyDown,
      onChange
     }}
    />
   </div>
  </Flex>
 );
};

Dues.propTypes = {
 num: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
 type: PropTypes.string.isRequired,
 watch: PropTypes.func.isRequired,
 setValue: PropTypes.func.isRequired,
 register: PropTypes.func.isRequired,
 errors: PropTypes.object.isRequired,
 verifyFields: PropTypes.func.isRequired
};

export default Dues;
